export default __webpack_public_path__ + "static/media/Condition-Management-Bg.1946309f.svg";